import { render, staticRenderFns } from "./ShippingEtaBox.vue?vue&type=template&id=2f752195"
import script from "./ShippingEtaBox.vue?vue&type=script&lang=js"
export * from "./ShippingEtaBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports